/**
 * CoursesProvider - Global courses data provider
 * 
 * Reduces function calls from N (one per component) to 1 (app-wide).
 */
import { useEffect } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import { useCoursesStore } from '@/store/use-courses-store';

export const CoursesProvider = ({ children }: { children: React.ReactNode }) => {
    const { setCourses, setIsLoading } = useCoursesStore();

    // SINGLE app-wide query - all components share this result
    const coursesData = useQuery(api.courses.get, {
        search: undefined,
        limit: 50,
        minimal: true,
        includeDocumentCounts: false
    });

    // Update store when data changes (Convex handles reactivity)
    useEffect(() => {
        if (coursesData !== undefined) {
            setCourses(coursesData);
        } else {
            setIsLoading(true);
        }
    }, [coursesData, setCourses, setIsLoading]);

    return <>{children}</>;
};
